import { helpers } from '@vuelidate/validators'

export const regularExpresionValidator = (regExp: RegExp, message: string) =>
  helpers.withMessage(
    () => message ?? 'EL valor no cumple con el formato',
    helpers.withParams({ regExp }, (val: string) => !helpers.req(val) || !!val.match(regExp))
  )
